import React from 'react';

const FAQ_ITEMS = [
  { q: 'Posso solicitar 2ª via do diploma?', a: 'Sim! Você pode solicitar quantas vias precisar.' },
  { q: 'Quanto tempo leva para receber o diploma?', a: 'Em até 10 dias úteis após confirmação.' },
  { q: 'O site profissional é hospedado em qualquer servidor?', a: 'Não, ele é hospedado em nossos servidores.' },
  { q: 'Preciso estar Filiado para contratar os serviços?', a: 'Alguns serviços podem requerer filiação ativa.' },
  { q: 'Há suporte técnico disponível?', a: 'Sim, suporte via e-mail, chat ou telefone.' },
];

const ServicosFAQ: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-color-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h2 className="text-3xl font-bold text-color-text text-center mb-12">
          Perguntas Frequentes
        </h2>

        <div className="space-y-4">
          {FAQ_ITEMS.map((item, idx) => (
            <details key={idx} className="group border border-color-border rounded-lg">
              <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-color-surface">
                <span className="font-bold text-color-text">{item.q}</span>
                <span className="text-color-text-secondary group-open:rotate-180 transition-transform">
                  ▼
                </span>
              </summary>
              <div className="px-6 pb-6 text-color-text-secondary">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicosFAQ;
